import {
  resetFetch,
  selectFavoriteFilter,
  selectTag,
} from "@shared/actions/games";
import { Button } from "@shared/components";
import { SHOW_ALL } from "@shared/constants/game";
import { useCurrentTagId } from "@shared/hooks/games";
import {
  useComputedGames,
  useFavoriteGamesCount,
  useIsFavoriteFilterActive,
} from "@shared/hooks/games/games";
import { useIsAuth } from "@shared/hooks/user";
import {
  TAG_RECOMMENDED,
  useRecommendationGames,
} from "@shared/modules/recommended-games";
import React, { memo, useEffect } from "react";
import { useIntl } from "react-intl";
import { useDispatch } from "react-redux";

import Card from "./CardGame";

const CatalogGames = () => {
  const computedGames = useComputedGames();
  const dispatch = useDispatch();
  const isAuth = useIsAuth();
  const isFavoriteFilterActive = useIsFavoriteFilterActive();
  const currentTagId = useCurrentTagId();
  const { recommendationGames } = useRecommendationGames();
  const favoriteGamesCount = useFavoriteGamesCount();
  const intl = useIntl();

  useEffect(() => {
    if (!isAuth) {
      dispatch(selectTag(SHOW_ALL));
      dispatch(selectFavoriteFilter(false));
    }
  }, [dispatch, isAuth]);

  useEffect(() => {
    return () => {
      dispatch(resetFetch());
    };
  }, [dispatch]);

  const renderCatalogGames = () => {
    if (currentTagId === TAG_RECOMMENDED) {
      return (
        <>
          <div
            style={{
              margin: "10px 0 20px 6px",
              fontSize: "20px",
              width: "100%",
              textAlign: "center",
            }}
          >
            <p>
              {intl.formatMessage({
                id: "boilerplate.recommendations.Text1",
              })}
              .
            </p>
            <p>
              {" "}
              {intl.formatMessage({
                id: "boilerplate.recommendations.Text2",
              })}
              .
            </p>
          </div>
          {recommendationGames.map((game) => (
            <Card key={game.id} auth={isAuth} {...game} />
          ))}
        </>
      );
    }

    return computedGames.map((game) => (
      <Card key={game.id} auth={isAuth} {...game} />
    ));
  };

  return (
    <div className="catalog" role="list" data-count={computedGames.length}>
      <div className="catalog__bg" />
      {renderCatalogGames()}
      {favoriteGamesCount === 0 && isFavoriteFilterActive && (
        <>
          <div className="catalog__empty">
            <p className="empty-favorite-list">
              {intl.formatMessage({
                id: "boilerplate.components.GamesFavoriteCatalog.Empty.Text",
              })}
            </p>
            <p className="empty-favorite-list">
              {intl.formatMessage({
                id: "boilerplate.components.GamesFavoriteCatalog.Empty.TextTwo",
              })}
            </p>
            <div className="button-back-empty-favorite-list">
              <Button
                tagName="button"
                className="btn btn--secondary btn--lg object__btn"
                variant="primary"
                onClick={() => dispatch(selectFavoriteFilter(false))}
              >
                {intl.formatMessage({
                  id: "boilerplate.components.GameMessage.Link",
                })}
              </Button>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default memo(CatalogGames);
